// Config
import isClickAndCollectAvailable from '../collection/isClickAndCollectAvailable';
import { isClickAndCollectChoice, isDeliveryChoice } from './deliveryHelper';

export default function getDeliveryTitleText(state) {
  const {
    delivery: {
      deliveryOptions = {},
      selectedDeliveryChoiceId,
    } = {},
    user: {
      selectedDeliveryAddress,
      collectionPoints,
    } = {},
  } = state;

  const clickAndCollectAvailable = isClickAndCollectAvailable(deliveryOptions);
  if (!clickAndCollectAvailable) return '1. Delivery';

  const deliverySelected = isDeliveryChoice(selectedDeliveryChoiceId);
  const clickCollectSelected = isClickAndCollectChoice(selectedDeliveryChoiceId);

  const showSavedDeliveryOptionTitle =
    (deliverySelected && selectedDeliveryAddress) ||
    (clickCollectSelected && collectionPoints?.length > 0);
  const titleText = showSavedDeliveryOptionTitle ? '1. Delivery option' : '1. Select a delivery option';

  return titleText;
}
